import React from 'react';
import { createPortal } from 'react-dom';

import { IconButton, Surface } from '@infoods/lifebase-ui';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

import classes from './ConsumptionBetweenWidget.module.scss';
import { ConsumptionBetweenTable } from '../ConsumptionBetweenTable/ConsumptionBetweenTable';
import { ConsumptionInfo } from '../../../interfaces/consumption/ConsumptionInfo';
import { getFormattedDate } from '../../../../shared/utils/dateUtils';
import { localDataFormat } from '../../../../shared/constants/apiDateFormat';

type ConsumptionBetweenWidgetProps = {
  firstName: string;
  lastName: string;
  consumptionInfo: ConsumptionInfo;
  onClose: () => void;
};

const ConsumptionBetweenWidget = ({
  firstName,
  lastName,
  consumptionInfo,
  onClose,
}: ConsumptionBetweenWidgetProps) => {
  if (!consumptionInfo) {
    return null;
  }

  const formattedFrom = getFormattedDate(consumptionInfo.startDate, localDataFormat);
  const formattedTo = getFormattedDate(consumptionInfo.endDate, localDataFormat);

  return createPortal(
    <Surface className={classes.widgetBox} data-test-id="consumption-between-widget">
      <div className={classes.titleBox} data-test-id="consumption-widget-title">
        <div className={classes.titleInfo}>
          <h5>
            Consumption Between {formattedFrom} - {formattedTo}
          </h5>
          <p className="private-info">
            <span>{firstName}</span>
            &nbsp;
            <span>{lastName}</span>
          </p>
        </div>
        <IconButton onClick={onClose}>
          <CloseRoundedIcon fontSize="large" />
        </IconButton>
      </div>
      <ConsumptionBetweenTable
        goal={consumptionInfo.goal}
        actual={consumptionInfo.actual}
      />
    </Surface>,
    document.body,
  );
};

export { ConsumptionBetweenWidget };
